import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const AfectacionVentaFormGroup = ({
  values,
  setValues,
  iError,
  iTouched,
  fIsSubmitting,
  afectacionesVentas
}) => {
  React.useEffect(() => {
    if (afectacionesVentas.length === 1) {
      values._idAfectacionVenta = afectacionesVentas[0]._id
      setValues(values)
    }
  }, [afectacionesVentas, values, setValues])

  return (
    <Form.Group>
      <Form.Label
        text='VENTAS'
        htmlFor='select-afectacionesVentas'
        sm={2}
        md={3}
        lg={2}
        alignRightAt='sm'
      />
      <Col sm={10} md={9} lg={10}>
        <Field name='afectacionVenta'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-afectacionesVentas'
            >
              <option value=''>Seleccionar</option>
              {afectacionesVentas &&
                afectacionesVentas.map((val, key) => (
                  <option key={key} value={val._id}>
                    {val.nombre}
                  </option>
                ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(AfectacionVentaFormGroup)
